import React from 'react'
import EVENTS from '../../utils/events'
import LinkRounded from '../../components/LinkRounded'
import {
  AccountDropDown,
  SubMenu,
  Menu,
  Favourites,
  Login,
  LoginSmallText,
  Count,
  Counter,
  IconProfile
} from './components'
import IconArrowDown from '../../vectors/IconArrowDown'
import IconAccountHeart from '../../vectors/IconAccountHeart'
import { withFavouritesContext } from '../../context/favourites'
import { Grid } from '../../utils/style'

class RouterAccount extends React.PureComponent {
  constructor(props) {
    super(props)
    this.isWindowAvailable = typeof window !== 'undefined'
    this.addEventListeners = this.addEventListeners.bind(this)
    this.removeEventListeners = this.removeEventListeners.bind(this)
    this.handleKeyPressed = this.handleKeyPressed.bind(this)
    this.handleOnClick = this.handleOnClick.bind(this)
    this.hide = this.hide.bind(this)
    this.show = this.show.bind(this)
    this.logout = this.logout.bind(this)
    this.state = {
      hidden: true
    }
  }

  addEventListeners() {
    if (this.isWindowAvailable) {
      window.addEventListener('keydown', this.handleKeyPressed)
    }
  }

  removeEventListeners() {
    if (this.isWindowAvailable) {
      window.removeEventListener('keydown', this.handleKeyPressed)
    }
  }

  hide() {
    this.setState({ hidden: true })
    this.removeEventListeners()
    if (this.isWindowAvailable) {
      window.dispatchEvent(new Event(EVENTS.CONTENT.DIMMER_OFF))
    }
  }
  show() {
    this.setState({ hidden: false })
    this.addEventListeners()
    if (this.isWindowAvailable) {
      window.dispatchEvent(
        new CustomEvent(EVENTS.CONTENT.DIMMER_ON, {
          detail: EVENTS.CTRL.PRIMARY
        })
      )
    }
  }

  handleKeyPressed(_e) {
    // esc
    if (!_e.keyCode || _e.keyCode === 27) {
      this.hide()
    }
  }

  handleOnClick(_e) {
    _e.preventDefault()
    if (this.state.hidden) {
      this.show()
    } else {
      this.hide()
    }
  }

  logout() {
    this.props.context.logout()
  }

  render() {
    const handleMouseEnter = () => {
      if (this.state.hidden) this.show()
    }
    const handleMouseLeave = () => {
      if (!this.state.hidden) this.hide()
    }

    const classHidden = this.state.hidden ? 'closed' : 'open'

    return (
      <Grid>
        {!this.props.nofavouritesicon && (
          <Favourites mx={1} pt={[14, null, 15]} pb={[12, null, 15]}>
            <a
              href={`${process.env.GATSBY_PORTAL_URL}/favourites`}
              target="_blank"
              rel="noreferrer"
            >
              <IconAccountHeart />
              {this.props.context && (
                <Counter>{this.props.context.length}</Counter>
              )}
            </a>
          </Favourites>
        )}
        <AccountDropDown
          id="account-drop-down"
          role="tablist"
          pt={[14, null, 15]}
          pb={[12, null, 15]}
          pl={[10, null, 12]}
          pr={[8, null, 10]}
          width={'56px'}
          className={classHidden}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
        >
          <a
            href="/"
            className="profile"
            aria-haspopup="true"
            aria-label="Profile"
            role="tab"
            onClick={this.handleOnClick}
          >
            <IconProfile />
            <span className="arrow">
              <IconArrowDown />
            </span>
          </a>

          <SubMenu aria-label="submenu">
            <Menu className="account__menu">
              <a
                href={`${process.env.GATSBY_PORTAL_URL}/favourites`}
                tabIndex={this.state.hidden ? -1 : 0}
                target="_blank"
                rel="noreferrer"
              >
                My Favourites{' '}
                {this.props.context && (
                  <Count>({this.props.context.length})</Count>
                )}
              </a>
              {!this.props.context.user && (
                <Login py={18}>
                  <LinkRounded
                    href={`${process.env.GATSBY_PORTAL_URL}/auth/login`}
                    stretched
                    tabIndex={this.state.hidden ? -1 : 0}
                    target="_blank"
                    rel="noreferrer"
                  >
                    Log in
                  </LinkRounded>
                  <LoginSmallText fontSize={0} pt={'7px'}>
                    or set up account{' '}
                    <a
                      href={`${process.env.GATSBY_PORTAL_URL}/auth/register`}
                      target="_blank"
                      rel="noreferrer"
                    >
                      here
                    </a>
                  </LoginSmallText>
                </Login>
              )}
              {this.props.context.user && [
                <a
                  href={`${process.env.GATSBY_PORTAL_URL}`}
                  tabIndex={this.state.hidden ? -1 : 0}
                  key="link-profile"
                  target="_blank"
                  rel="noreferrer"
                >
                  Portal
                </a>,
                <Login py={18} key="link-logout">
                  <LinkRounded
                    onClick={this.logout}
                    stretched
                    tabIndex={this.state.hidden ? -1 : 0}
                  >
                    Log out
                  </LinkRounded>
                </Login>
              ]}
            </Menu>
          </SubMenu>
        </AccountDropDown>
      </Grid>
    )
  }
}

export default withFavouritesContext(RouterAccount)
